export default {
  "associates": {
    "title": "Members",
    "search_placeholder": "Search member...",
    "view_profile": "🔍 View Profile",
    "no_results": "No member found.",
    "back_to_home": "Back to Home",
    "about": "About",
    "products": "Products",
    "certifications": "Certifications",
    "show":"Show",
    "all":"All",
  }
}
